export function formatVictimName(
  victimCompanyName?: string,
  victimFirstName?: string,
  victimLastName?: string,
  victimPersonCompanyName?: string,
): string {
  if (victimCompanyName) {
    return victimCompanyName;
  }

  if (victimFirstName && victimLastName) {
    return victimPersonCompanyName
      ? `${victimFirstName} ${victimLastName} (${victimPersonCompanyName})`
      : `${victimFirstName} ${victimLastName}`;
  }

  return victimPersonCompanyName || "";
}
